<script setup lang="ts">
import type { IconConstant } from '@tpg/grammar-web-icons';
import {
  tpgIconClose,
  tpgIconLayersFull,
  tpgIconMap,
} from '@tpg/grammar-web-icons';

import {
  GrammarIcon,
  GrammarOverlayCard,
  GrammarPrimaryButton,
  GrammarQuaternaryButton,
} from '@nora-monorepo/grammar-ui';

import { useMapStore } from '#nora-ui/map/stores/map-store';

interface Props {
  mapId: string;
  iconTemplate: IconConstant;
  heading: string;
  message: string;
}
const props = defineProps<Props>();
const { mapId } = props;

const mapStore = useMapStore();
const map = mapStore.getMapByIdOrThrow(mapId);
const drawToolUI = map.drawToolUI;

function onClose() {
  drawToolUI.isToolListOpen.value = false;
}

function onOpenLayers() {
  map.state.draw.setDrawLayerMenuOpen(true);
}
</script>

<template>
  <GrammarOverlayCard
    class="w-[288px] override-min-width pointer-events-auto"
    :leading-icon-template="tpgIconMap"
    heading-label="Draw and map tools"
  >
    <template #header-trailing-buttons>
      <GrammarQuaternaryButton
        :icon-template="tpgIconClose"
        @click="onClose"
      />
    </template>
    <div class="flex flex-col gap-4 items-center p-4 text-light-label-secondary dark:text-primary-300">
      <GrammarIcon
        :icon-template="props.iconTemplate"
        size="large"
      />
      <h2 class="text-xl">
        {{ props.heading }}
      </h2>
      <p class="text-center">
        {{ props.message }}
      </p>
    </div>
    <template #footer>
      <div class="p-2">
        <GrammarPrimaryButton
          label="Open layers"
          :icon-template="tpgIconLayersFull"
          @click="onOpenLayers"
        />
      </div>
    </template>
  </GrammarOverlayCard>
</template>
